// extracted by mini-css-extract-plugin
export default {"container":"CrmGridAddDecimalFilterDialog_container__rksC1","invalidSpan":"CrmGridAddDecimalFilterDialog_invalidSpan__E5+GS"};